import 'isomorphic-unfetch';

import { searchParams } from '@tb-core/helpers/url';
import { RealObject } from '@tb-core/types';

export type RequestMethod = 'DELETE' | 'GET' | 'POST' | 'PUT';

export interface FetchOptions extends RequestInit {
    body?: BodyInit;
    host?: string;
    method?: RequestMethod;
    payload?: RealObject;
    url: string;
    useDefaultHost?: boolean;
}

export default async function Fetch({
    body,
    credentials = 'include',
    headers = {},
    host = 'http://localhost:3000',
    method = 'GET',
    payload,
    url = '',
    useDefaultHost = true
}: FetchOptions) {
    const baseUrl = useDefaultHost === false ? url : host + url;
    const opts: RequestInit = {
        body: body || undefined,
        credentials,
        headers,
        method
    };

    const resource = payload ? searchParams(baseUrl, payload) : baseUrl;
    console.time(resource);
    const res = await fetch(resource, opts);
    console.timeEnd(resource);

    return res;
}
